export default __webpack_public_path__ + "static/SR USA - Caramel Color Application Guide-19499d4073975a1b73ae2cec8ced9d9a.pdf";